module.exports = __webpack_public_path__ + "img/4Q.a25b10f7.png";